module.exports = __webpack_public_path__ + "img/rux-surfboard.bab047ff.jpg";